module.exports = __webpack_public_path__ + "img/65.f2bd0cf3.png";